import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = ["content"]
const _hoisted_3 = { class: "date-picker-presets" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "day" }

import {
  computed,
  ref,
  toRaw,
  watch,
} from "vue";
import {
  endOfMonth,
  startOfMonth,
  startOfToday,
  startOfYesterday,
  subMonths,
  subWeeks,
  format,
} from "date-fns";
import isEqual from "lodash/isEqual";
import "@vuepic/vue-datepicker/dist/main.css";
import { VIconSvg } from "@/components";
import { TranslateResult } from "vue-i18n";
import VErrorTooltip from "@/components/VErrorTooltip/VErrorTooltip.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import { includes } from "lodash";

export default /*@__PURE__*/_defineComponent({
  __name: 'VInputDatepickerNext',
  props: {
    initPreset: { default: undefined },
    showResetButton: { type: Boolean, default: false },
    label: { default: "" },
    value: { default: "" },
    range: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    minDate: { default: "" },
    maxDate: { default: "" },
    disabledDates: { default: () => [] },
    error: { default: "" },
    required: { type: Boolean, default: false },
    description: { default: "" },
    mode: { default: "date" }
  },
  emits: ["input", "click"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

VueDatePicker.compatConfig = { MODE: 3 };

const emit = __emit;

const props = __props;

const vueDatePickerRef = ref();

const dateValue = computed({
  get() {
    return props.value;
  },

  set(value) {
    emit("input", value);
  },
});

const presets = computed(() => {
  const today = startOfToday();
  const yesterday = startOfYesterday();
  const oneMonthAgo = subMonths(today, 1);

  return [
    {
      label: "Today",
      code: "today",
      value: [today, today],
      active: false,
    },
    {
      label: "Yesterday",
      code: "yesterday",
      value: [yesterday, yesterday],
      active: false,
    },
    {
      label: "Last 7 days",
      code: "lastSevenDays",
      value: [subWeeks(today, 1), today],
      active: false,
    },
    {
      label: "Last 30 days",
      code: "lastThirtyDays",
      value: [oneMonthAgo, today],
      active: false,
    },
    {
      label: "This month",
      code: "thisMonth",
      value: [startOfMonth(today), today],
      active: false,
    },
    {
      label: "Last month",
      code: "lastMonth",
      value: [startOfMonth(oneMonthAgo), endOfMonth(oneMonthAgo)],
      active: false,
    },
  ].map((preset) => {
    const [from, to] = preset.value;

    preset.value = [format(from, dateFormat.value), format(to, dateFormat.value)];
    preset.active = isEqual(toRaw(dateValue.value), toRaw(preset.value));

    return preset;
  });
});

const wrapperClasses = computed(() => {
  return {
    disabled: props.disabled,
    single: !props.range,
    "input-required": props.required,
    "date-time-picker": props.mode === "dateTime",
    "input-error": props.error,
  };
});

const timepicker = computed(() => {
  return props.mode === "dateTime";
});

const dateFormat = computed(() => (timepicker.value ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"));
const userFormat = computed(() => (timepicker.value ? "MM/dd/yyyy HH:mm" : "MM/dd/yyyy"));

const tippyConfig = computed(() => {
  return { onShow: () => !!props.description };
});

const isShownResetButton = computed(() => {
  return (
    props.showResetButton && (props.range ? !includes(dateValue.value, "") : !!dateValue.value)
  );
});

const applyPreset = (presetCode: string) => {
  const preset = presets.value.find((preset) => presetCode === preset.code);

  if (preset) dateValue.value = preset.value;
};

const onClickResetButton = () => {
  dateValue.value = props.range ? ["", ""] : "";
};

const toggle = () => {
  if (!props.disabled) {
    vueDatePickerRef.value.toggleMenu();
  }
};

const open = () => {
  if (!props.disabled) {
    vueDatePickerRef.value.openMenu();
  }
};

const onClick = () => {
  if (!props.disabled) {
    emit("click");
  }
};

watch(() => props.initPreset, applyPreset, { immediate: true });

__expose({
  toggle,
});

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    key: _ctx.value.length,
    class: _normalizeClass(["calendar-container", wrapperClasses.value]),
    onClick: onClick
  }, [
    (_ctx.label.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "datepicker-wrapper",
      "data-cy": "calendar-wrapper",
      content: _ctx.description,
      onClick: open
    }, [
      _createVNode(_unref(VIconSvg), {
        class: "calendar-icon",
        name: "Calendar",
        color: "fc-stroke"
      }),
      _createVNode(_unref(VueDatePicker), {
        ref_key: "vueDatePickerRef",
        ref: vueDatePickerRef,
        modelValue: dateValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
        clearable: false,
        "enable-time-picker": timepicker.value,
        "model-type": dateFormat.value,
        "preview-format": userFormat.value,
        "min-date": _ctx.minDate,
        "max-date": _ctx.maxDate,
        "disabled-dates": _ctx.disabledDates,
        disabled: _ctx.disabled,
        range: _ctx.range,
        placeholder: _ctx.$t('placeholder.datePicker'),
        position: "left",
        "auto-apply": "",
        "hide-input-icon": "",
        "month-name-format": "long",
        class: "date-picker"
      }, _createSlots({
        day: _withCtx(({ day }) => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(day), 1)
        ]),
        _: 2
      }, [
        (_ctx.range)
          ? {
              name: "left-sidebar",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presets.value, (preset, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["preset", { active: preset.active }]),
                      onClick: ($event: any) => (dateValue.value = preset.value)
                    }, _toDisplayString(preset.label), 11, _hoisted_4))
                  }), 128))
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "enable-time-picker", "model-type", "preview-format", "min-date", "max-date", "disabled-dates", "disabled", "range", "placeholder"]),
      (!isShownResetButton.value)
        ? (_openBlock(), _createBlock(_unref(VIconSvg), {
            key: 0,
            name: "ArrowDown",
            "color-tag": "stroke",
            size: "sm",
            class: "arrow-down"
          }))
        : _createCommentVNode("", true),
      (isShownResetButton.value)
        ? (_openBlock(), _createBlock(_unref(VIconSvg), {
            key: 1,
            class: "reset-button",
            name: "Close",
            "color-tag": "stroke",
            size: "sm",
            onClick: onClickResetButton
          }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)), [
      [_directive_tippy, tippyConfig.value]
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(VErrorTooltip, {
          key: 1,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})